import GeckoStore from '../services/gecko-store';

export const setLoggedInUser = (user) => {
  return { type: 'SET_LOGGED_IN_USER', payload: user };
};
export const deleteLoggedInUser = (user) => {
  return { type: 'SET_LOGGED_IN_USER', payload: '' };
};

export const setAccount = (account) => {
  return { type: 'SET_ACCOUNT', payload: account };
};

export const setJWT = (jwt) => {
  GeckoStore.localStorage.set('jwtToken', jwt);
  return { type: 'SET_JWT', payload: jwt };
};

export const setIsSupport = (isSupport) => {
  return { type: 'SET_IS_SUPPORT', payload: isSupport };
};

export const setAPIURL = (apiUrl) => {
  return { type: 'SET_API_URL', payload: apiUrl };
};

export const setDateFormat = (format) => {
  return { type: 'SET_DATE_FORMAT', payload: format };
};

export const setFeatures = (features) => {
  return { type: 'SET_FEATURES', payload: features };
};

export const setProfiles = (profiles) => {
  return { type: 'SET_PROFILES', payload: profiles };
};

export const clearLogin = () => {
  GeckoStore.localStorage.set('jwtToken', null);
  return { type: 'CLEAR_LOGIN', payload: null };
};

export const deleteJWT = () => {
  return { type: 'DELETE_JWT', payload: '' };
};

export const setDefaultHeaders = (headers) => {
  return { type: 'SET_DEFAULT_HEADERS', payload: headers };
};

export const deleteDefaultHeaders = () => {
  return { type: 'DELETE_DEFAULT_HEADERS', payload: '' };
};

export const setConversationFilter = (filter) => {
  return { type: 'SET_CONVERSATION_FILTER', payload: filter };
};

export const userWasDisconnected = () => {
  return { type: 'USER_WAS_DISCONNECTED' };
};

export const userWasConnected = () => {
  return { type: 'USER_WAS_CONNECTED' };
};
